import React from "react";

import { Typography, Box, Container } from "@mui/material";

const Contact = () => {
  return (
    <Box
      component="footer">
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "10vh"
        }}
      >
        <Typography sx={{ color: "#66fcf1", textAlign: "center" }}>
          &copy;2024 diego-rg
        </Typography>
      </Container>
    </Box>
  );
};
export default Contact;
